module.exports = __webpack_public_path__ + "static/media/CITI.8b75c5f5.svg";